import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * PageLink - A wrapper that renders a standard HTML a with Bulma class names
 *
 * This component accepts the same props as Bloomer PageLink for easy migration
 */
const PageLink = ({ className, children, style, isCurrent, onClick, ...props }) => {
  // Build the class names based on props
  const getClassNames = () => {
    return classNames('pagination-link', {
      'is-current': isCurrent,
      [className]: className,
    });
  };

  return (
    <a 
      className={getClassNames()} 
      style={style} 
      onClick={onClick}
      aria-current={isCurrent ? 'page' : undefined}
      aria-label={`Page ${children}`}
      {...props}
    >
      {children}
    </a>
  );
};

PageLink.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  isCurrent: PropTypes.bool,
  onClick: PropTypes.func,
};

PageLink.defaultProps = {
  className: '',
  style: {},
  children: null,
  isCurrent: false,
  onClick: null,
};

export default PageLink;
